<template>
  <div class="tw-mb-4 tw-flex tw-flex-col" role="group">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped></style>
